import React from 'react';
import { Shield } from 'lucide-react';

/**
 * Компонент секции страховки
 */
const InsuranceSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-100 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-green-500" />
        Туристическая страховка
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Количество дней страховки */}
        <div>
          <label htmlFor="insuredDays" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество дней страховки
          </label>
          <input
            type="text"
            id="insuredDays"
            name="insuredDays"
            value={formData.insuredDays}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.insuredDays ? 'input-error' : ''}`}
            placeholder="Введите количество дней"
          />
          {errors.insuredDays && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.insuredDays}
            </p>
          )}
        </div>

        {/* Тип страхового покрытия */}
        <div>
          <label htmlFor="insuranceCoverage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип страхового покрытия
          </label>
          <select
            id="insuranceCoverage"
            name="insuranceCoverage"
            value={formData.insuranceCoverage}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="standard">Стандартное (30 000 €)</option>
            <option value="extended">Расширенное (50 000 €)</option>
            <option value="premium">Премиум (100 000 €)</option>
          </select>
        </div>
      </div>

      {/* Информационный блок о страховке */}
      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-gray-200 dark:border-gray-700 text-sm">
        <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-2">
          Что включает туристическая страховка:
        </h4>
        <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
          <li>• Экстренная медицинская помощь</li>
          <li>• Госпитализация при несчастном случае или заболевании</li>
          <li>• Транспортировка в медицинское учреждение</li>
          <li>• Медицинская эвакуация и репатриация</li>
          <li>• Страхование медицинских расходов</li>
          {formData.insuranceCoverage === 'extended' && (
            <>
              <li>• Стоматологическая помощь при острой боли</li>
              <li>• Компенсация в случае утери багажа</li>
            </>
          )}
          {formData.insuranceCoverage === 'premium' && (
            <>
              <li>• Стоматологическая помощь при острой боли</li>
              <li>• Компенсация в случае утери багажа</li>
              <li>• Отмена или прерывание поездки</li>
              <li>• Страхование гражданской ответственности</li>
              <li>• Юридическая помощь за рубежом</li>
            </>
          )}
        </ul>
        <p className="mt-2 text-xs text-green-600 dark:text-green-400">
          Для шенгенской визы требуется страховка с минимальным покрытием 30 000 евро. Для США и некоторых других стран рекомендуется более высокое покрытие.
        </p>
      </div>
    </div>
  );
};

export default InsuranceSection;